import axios from "axios";

axios.interceptors.request.use(function (config) {
  if (window.localStorage.getItem("Token"))
    config.headers.Authorization = `${window.localStorage.getItem("Token")}`;
  return config;
});

axios.interceptors.response.use(
  function (response) {
    if (
      response?.data?.message &&
      [
        "Unauthorized request",
        "You are already logged in on another device.",
      ].includes(response.data.message)
    ) {
      window.localStorage.removeItem("Token");
      window.localStorage.removeItem("hasSeenTour");
      window.localStorage.removeItem("giveProfileChance");
      window.localStorage.removeItem("ProfileImage");
      window.sessionStorage.clear();
      window.location.href = "/";
    }
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      window.localStorage.removeItem("Token");
      window.localStorage.removeItem("hasSeenTour");
      window.localStorage.removeItem("giveProfileChance");
      window.localStorage.removeItem("ProfileImage");
      window.sessionStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

function errorRedirect(msg) {
  console.log("API Response Error:", msg);
}

export function Post(url, payload, config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        reject(e);
      });
  });
}

export function Postdata(url, payload, config = {}) {
  let header = config;
  if (!("headers" in header)) {
    header = Object.assign(
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      header
    );
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, header)
      .then((response) => {
        response.data.message =
          response.data.message == "Authorization required"
            ? "Under Development..."
            : response.data.message;
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        e.message =
          e.message == "Network Error" ? "Something went wrong!!!" : e.message;
        reject(e);
      });
  });
}

export function PostdataforEditProfile(url, payload, config = {}) {
  let header = config;
  if (!("headers" in header)) {
    header = Object.assign(
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      header
    );
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, header)
      .then((response) => {
        response.data.message =
          response.data.message == "Authorization required"
            ? "Under Development..."
            : response.data.message;
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        e.message =
          e.message == "Network Error" ? "Something went wrong!!!" : e.message;
        reject(e);
      });
  });
}

export function Put(url, payload, config) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, payload, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        reject(e);
      });
  });
}

export function Get(url, config) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        reject(e);
      });
  });
}

export function Delete(url, config) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        errorRedirect(e.message);
        reject(e);
      });
  });
}
